import React from 'react'
import styled from "styled-components";

const EXTERNAL_LINK = styled.a`
  cursor: pointer;
`;

export const ExternalLink = ({
  id,
  type,
  children,
  onClick,
  ...rest
}) => {
  const handleOnclick = e => {
    e.preventDefault();
    onClick();
  };

  return (
    <EXTERNAL_LINK onClick={handleOnclick} href={id} {...rest}>
      {children}
    </EXTERNAL_LINK>
  );
};